import _throttle from 'lodash/throttle'
import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class Throttle<V = any, E = any, C = any, T = V> extends Pass<V, E, C> {
    protected last: T | undefined

    constructor(
        protected source?: AnySourceStream<V, E, C>,
        protected wait?: number,
        protected options?: { leading?: boolean; trailing?: boolean }
    ) {
        super(source)
        this.throttledValue = _throttle(this._value, wait, options)
    }

    throttledValue = _throttle(this._value, this.wait, this.options)

    value(value: V) {
        this.throttledValue(value)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        throttle<T = DV>(wait?: number, options?: { leading?: boolean; trailing?: boolean }): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.throttle = function <V, E, C, T = V>(
    this: AnySourceStream<V, E, C>,
    wait?: number,
    options?: { leading?: boolean; trailing?: boolean }
) {
    return new Throttle(this, wait, options) // tslint:disable-line:no-invalid-this
}
